import { MessagingAirMetricDefinition } from './messaging-air-metrics.types';
import { messagingAirFlagsMetric } from './metrics/messaging-air-flags';
import { truelarkBusinessIdMetric } from '../voice-air-handoff/metrics/truelark-business-id';
import { tenDlcRegisteredMetric } from '../voice-air-handoff/metrics/ten-dlc-registered';
import { businessPreferencesMetric } from '../voice-air-handoff/metrics/business-preferences';
import { schedulingServiceTypeMetric } from '../voice-air-handoff/metrics/scheduling-service-type';
import { providerOperatoryAvailableMetric } from '../voice-air-handoff/metrics/provider-operatory-available';
import { phoneOfficeHoursMetric } from '../voice-air-handoff/metrics/phone-office-hours';
import { aiMissedCallTextMetric } from '../voice-air-handoff/metrics/ai-missed-call-text';
import { messagingAiTasksReviewedMetric } from './metrics/messaging-ai-tasks-reviewed';

export const MESSAGING_AIR_METRIC_DEFINITIONS: MessagingAirMetricDefinition[] = [
  messagingAirFlagsMetric,
  truelarkBusinessIdMetric,
  tenDlcRegisteredMetric,
  businessPreferencesMetric,
  schedulingServiceTypeMetric,
  providerOperatoryAvailableMetric,
  phoneOfficeHoursMetric,
  aiMissedCallTextMetric,
  messagingAiTasksReviewedMetric,
  // TODO: Missed Call Text Sent Verification Metric
];
